/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo } from 'react'
import { Html, Line } from '@react-three/drei'
import { const_var, params } from '../../../../../../../redux/reducers/reducer'

const OutLineSection = () => {
    const freeSpace = 0.2;

    const camPosX = const_var?.camera.position?.x;
    let offset = 1
    if(camPosX >= 0) offset = 1;
    else if(camPosX < 0) offset = -1;

    const frontLinePoints = useMemo(() => ([
        [-params.leanB_p_w / 2 - freeSpace, 0.15, -(params.p_d / 2 + parseInt(params.add_storage_back) + freeSpace * 2)],
        [params.leanB_p_w / 2 + freeSpace, 0.15, -(params.p_d / 2 + parseInt(params.add_storage_back) + freeSpace * 2)],
        [params.leanB_p_w / 2 + freeSpace, params.leanB_p_h - freeSpace, -(params.p_d / 2 + parseInt(params.add_storage_back) + freeSpace * 2)],
        [-params.leanB_p_w / 2 - freeSpace, params.leanB_p_h - freeSpace, -(params.p_d / 2 + parseInt(params.add_storage_back) + freeSpace * 2)],
        [-params.leanB_p_w / 2 - freeSpace, 0.15, -(params.p_d / 2 + parseInt(params.add_storage_back) + freeSpace * 2)],
    ]), [params.p_d, params.leanB_p_w, params.leanB_p_h, params.add_storage_back])

    const backLinePoints = useMemo(() => ([
        [-params.leanB_p_w / 2 - freeSpace, 0.15, -(params.p_d / 2 - freeSpace * 2)],
        [params.leanB_p_w / 2 + freeSpace, 0.15, -(params.p_d / 2 - freeSpace * 2)],
        [params.leanB_p_w / 2 + freeSpace, params.leanB_p_h - freeSpace, -(params.p_d / 2 - freeSpace * 2)],
        [-params.leanB_p_w / 2 - freeSpace, params.leanB_p_h - freeSpace, -(params.p_d / 2 - freeSpace * 2)],
        [-params.leanB_p_w / 2 - freeSpace, 0.15, -(params.p_d / 2 - freeSpace * 2)],
    ]), [params.p_d, params.leanB_p_w, params.leanB_p_h])

    const rightTopLinePoints = useMemo(() => ([
        [params.leanB_p_w / 2 + freeSpace, params.leanB_p_h - freeSpace, -(params.p_d / 2 - freeSpace * 2)],
        [params.leanB_p_w / 2 + freeSpace, params.leanB_p_h - freeSpace, -(params.p_d / 2 + parseInt(params.add_storage_back) + freeSpace * 2)],
    ]), [params.p_d, params.leanB_p_w, params.leanB_p_h, params.add_storage_back])

    const rightBottomLinePoints = useMemo(() => ([
        [params.leanB_p_w / 2 + freeSpace, 0.15, -(params.p_d / 2 - freeSpace * 2)],
        [params.leanB_p_w / 2 + freeSpace, 0.15, -(params.p_d / 2 + parseInt(params.add_storage_back) + freeSpace * 2)],
    ]), [params.p_d, params.leanB_p_w, params.leanB_p_h, params.add_storage_back])

    const leftTopLinePoints = useMemo(() => ([
        [-(params.leanB_p_w / 2 + freeSpace), params.leanB_p_h - freeSpace, -(params.p_d / 2 - freeSpace * 2)],
        [-(params.leanB_p_w / 2 + freeSpace), params.leanB_p_h - freeSpace, -(params.p_d / 2 + parseInt(params.add_storage_back) + freeSpace * 2)],
    ]), [params.p_d, params.leanB_p_w, params.leanB_p_h, params.add_storage_back])

    const leftBottomLinePoints = useMemo(() => ([
        [-(params.leanB_p_w / 2 + freeSpace), 0.15, -(params.p_d / 2 - freeSpace * 2)],
        [-(params.leanB_p_w / 2 + freeSpace), 0.15, -(params.p_d / 2 + parseInt(params.add_storage_back) + freeSpace * 2)],
    ]), [params.p_d, params.leanB_p_w, params.leanB_p_h, params.add_storage_back])

    const renderLine = (points) => (
        <Line
            points={points}
            color="#00BE00"
            lineWidth={3}
            dashSize={0.3}
            gapSize={0.1}
            dashed
        />
    );

    return (
        <group position={[0, 0, 0.1]}>
            {renderLine(frontLinePoints)}
            {renderLine(backLinePoints)}
            {renderLine(rightTopLinePoints)}
            {renderLine(rightBottomLinePoints)}
            {renderLine(leftTopLinePoints)}
            {renderLine(leftBottomLinePoints)}

            <Html position={[offset * params.leanB_p_w / 2, params.leanB_p_h, -(params.p_d / 2 + parseInt(params.add_storage_back) / 2)]} style={{ pointerEvents: 'none' }}>
                <span style={{backgroundColor: 'white', border: 'solid 2px #00BE00', color: 'black', borderRadius: '50%', cursor: 'pointer', display:'flex', alignItems: 'center', justifyContent: 'center', padding: '3px', userSelect: 'none', fontSize: 'smaller'}}>
                    <i className='icon-drag-ico'/>
                </span>
            </Html>
        </group>
    )
}

export default OutLineSection